import httpclient from "../../../../Utils";
import { mapStatus } from "./constants";

export const fetchOrderDetails = async (searchOrderId) => {
  const API_URL = `delivery/reports/order-track/${searchOrderId.trim()}`;
  const res = await httpclient.get(API_URL);
  const { data } = res;

  if (data.status === 200) {
    const apiData = data.data;

    // Determine current status from order progress state
    const progressStates = apiData.order_progress_state || [];
    const lastProgressState =
      progressStates[progressStates.length - 1]?.progress_order_sate;
    const currentStatus = mapStatus(
      lastProgressState || apiData.order_information?.current_order_status
    );

    // Check if order has paused or unloaded states
    const hasPaused = progressStates.some(
      (p) => p.progress_order_sate === "paused"
    );
    const hasUnloaded = progressStates.some(
      (p) => p.progress_order_sate === "unload"
    );

    // Map order lines to items
    const items = (apiData.order_lines || []).map((line) => ({
      name: line.stock_description,
      stockCode: line.stock_code,
      quantity: line.order_qty,
      price: parseFloat(line.line_amount),
    }));

    // Map status history
    const statusHistory = (apiData.order_status_history || []).map(
      (history) => ({
        status: mapStatus(history.order_state),
        timestamp: history.action_date,
        notes: history.action,
        actionBy: history.action_by,
        other_files: history.other_files || [],
        signature_files: history.signature_files || [],
        delivery_receiver_name: history.delivery_receiver_name || "",
        delivery_receiver_phone: history.delivery_receiver_phone || "",
        order_delivery_reason: history.order_delivery_reason || "",
      })
    );

    // Check if order is delivered
    const isDelivered = currentStatus === "delivered";
    const deliveredHistory = statusHistory.find(
      (h) => h.status === "delivered"
    );

    // Create a map of status -> date for OrderProgressStepper
    // If a status appears multiple times, keep the last occurrence
    const progressStatesWithDates = {};
    progressStates.forEach((state) => {
      const mappedStatus = mapStatus(state.progress_order_sate);
      // console.log("debugginfg the progress date", mappedStatus)
      progressStatesWithDates[mappedStatus] = state.progress_action_date;
      // console.log("this is the date test",state.progress_action_date )
    });

    const transformedData = {
      orderId: apiData.order_information?.job_no,
      invoiceId : apiData.order_information?.invoice_no,
      orderDate: apiData.order_information?.order_date,
      customerName: apiData.customer_information?.customer_name,
      customerCode: apiData.customer_information?.customer_code,
      customerPhone: apiData.customer_information?.customer_phone?.trim(),
      customerEmail: apiData.customer_information?.customer_email?.trim(),
      deliveryAddress: apiData.customer_information?.customer_delivery_address,
      currentStatus,
      estimatedDelivery:
        apiData.order_information?.order_delivery_estimate_date,
      deliveredDate:
        isDelivered && deliveredHistory ? deliveredHistory.timestamp : null,
      deliveryTime: apiData.order_information?.order_delivery_time,
      bay: apiData.order_information?.bay,
      totalAmount: parseFloat(apiData.order_information?.total_amount || 0),
      items,
      statusHistory,
      progressStates: progressStates.map((p) =>
        mapStatus(p.progress_order_sate)
      ),
      progressStatesWithDates,
      hasPaused,
      hasUnloaded,
    };
console.log("transformed data", transformedData)
    return { success: true, data: transformedData };
  } else {
    return {
      success: false,
      error:
        data.message ||
        "Order not found. Please check the Order ID and try again.",
    };
  }
};

export const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  // Check if date is already formatted (from API)
  if (typeof dateString === "string" && dateString.includes("/")) {
    return dateString;
  }
  // Otherwise, format as Date object
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return dateString; // Return as is if invalid
  return date.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};
